import { useAxios } from 'zhooks'
import type { Options } from 'ahooks/lib/useRequest/src/types'

type ClothingParams = {
  sampleFolderId?: string
  containSubFolder?: string | number
  queryType?: string
  source?:string,
  startTime?:string,
  endTime?:string,
  storeTimeStart?:string,
  storeTimeEnd?:string,
  pageSize?: number
  pageNo?: number
}
export function useClothings(params: ClothingParams, options?:Options<any, any>) {
  return useAxios(async (axios) => {
    const res = await axios.post(
      `/backend-api/zhikuan/mn/sample/query-sample-info?pageSize=${params.pageSize}&pageNo=${params.pageNo}`,
      params
    )
    return res.data
  }, { refreshDeps: [params], ...options })
}
